import { useCurrentTracking } from './use-current-tracking';
export function useTrackingEvents() {
  var _useCurrentTracking$e, _useCurrentTracking;

  return (_useCurrentTracking$e = (_useCurrentTracking = useCurrentTracking()) === null || _useCurrentTracking === void 0 ? void 0 : _useCurrentTracking.events) !== null && _useCurrentTracking$e !== void 0 ? _useCurrentTracking$e : [];
}